import { isCivicWorld,civicCities,civicLandmarks } from './civicWorlds.ts'
import { isEuropeanWorld,europeanCities,europeanLandmarks } from './europeanWorlds.ts'
import { isAsianWorld,asianCities,asianLandmarks } from './asianWorlds.ts'
export const regionalCities={...europeanCities,...asianCities,...civicCities}
export const isRegionalWorld=(id:string|undefined):id is keyof typeof regionalCities=>isEuropeanWorld(id)||isAsianWorld(id)||isCivicWorld(id)
export const regionalLandmarks=(id:keyof typeof regionalCities)=>isCivicWorld(id)?civicLandmarks(id):isAsianWorld(id)?asianLandmarks(id):europeanLandmarks(id)
